var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget",class:{'is-scroll': _vm.scroll, 'is-loading': _vm.loading, 'is-slim': _vm.isSlim}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }